import React from 'react';

const TimeMotionVisualization = () => {
  return (
    <div className="w-full h-80 relative overflow-hidden rounded-lg bg-gradient-to-br from-slate-900 to-slate-800">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 800 320"
        className="absolute inset-0"
      >
        <defs>
          <linearGradient id="productiveGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#10b981" />
            <stop offset="100%" stopColor="#059669" />
          </linearGradient>
          
          <linearGradient id="nonValueGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ef4444" />
            <stop offset="100%" stopColor="#dc2626" />
          </linearGradient>
          
          <filter id="glow">
            <feGaussianBlur stdDeviation="2"/>
          </filter>
        </defs>

        {/* Main timeline */}
        <g transform="translate(50, 120)">
          {/* Timeline base */}
          <rect x="0" y="-4" width="700" height="8" rx="4" fill="rgba(255,255,255,0.1)"/>
          
          {/* Task Time - much smaller portions */}
          <rect x="0" y="-25" width="70" height="50" rx="6" fill="url(#productiveGrad)" opacity="0">
            <animate attributeName="opacity" values="0;0.9;0.9" dur="6s" fill="freeze"/>
          </rect>
          
          {/* Non-Value Add Time - repositioning */}
          <rect x="70" y="-25" width="120" height="50" rx="6" fill="url(#nonValueGrad)" opacity="0">
            <animate attributeName="opacity" values="0;0;0.9;0.9" dur="6s" fill="freeze"/>
          </rect>
          
          {/* Task Time */}
          <rect x="190" y="-25" width="80" height="50" rx="6" fill="url(#productiveGrad)" opacity="0">
            <animate attributeName="opacity" values="0;0;0;0.9;0.9" dur="6s" fill="freeze"/>
          </rect>
          
          {/* Non-Value Add Time - tool reloading */}
          <rect x="270" y="-25" width="100" height="50" rx="6" fill="url(#nonValueGrad)" opacity="0">
            <animate attributeName="opacity" values="0;0;0;0;0.9;0.9" dur="6s" fill="freeze"/>
          </rect>
          
          {/* Task Time */}
          <rect x="370" y="-25" width="60" height="50" rx="6" fill="url(#productiveGrad)" opacity="0">
            <animate attributeName="opacity" values="0;0;0;0;0;0.9;0.9" dur="6s" fill="freeze"/>
          </rect>
          
          {/* Non-Value Add Time - waiting */}
          <rect x="430" y="-25" width="150" height="50" rx="6" fill="url(#nonValueGrad)" opacity="0">
            <animate attributeName="opacity" values="0;0;0;0;0;0;0.9;0.9" dur="6s" fill="freeze"/>
          </rect>
          
          {/* Task Time */}
          <rect x="580" y="-25" width="120" height="50" rx="6" fill="url(#productiveGrad)" opacity="0">
            <animate attributeName="opacity" values="0;0;0;0;0;0;0;0.9" dur="6s" fill="freeze"/>
          </rect>
          
          {/* Labels for all segments */}
          <text x="35" y="5" textAnchor="middle" fill="#ffffff" fontSize="11" fontFamily="system-ui" fontWeight="500" opacity="0">
            <animate attributeName="opacity" values="0;0;1" dur="6s" fill="freeze"/>
            Assembly
          </text>
          
          <text x="130" y="5" textAnchor="middle" fill="#ffffff" fontSize="11" fontFamily="system-ui" fontWeight="500" opacity="0">
            <animate attributeName="opacity" values="0;0;0;1" dur="6s" fill="freeze"/>
            Repositioning
          </text>
          
          <text x="230" y="5" textAnchor="middle" fill="#ffffff" fontSize="11" fontFamily="system-ui" fontWeight="500" opacity="0">
            <animate attributeName="opacity" values="0;0;0;0;1" dur="6s" fill="freeze"/>
            Assembly
          </text>
          
          <text x="320" y="5" textAnchor="middle" fill="#ffffff" fontSize="11" fontFamily="system-ui" fontWeight="500" opacity="0">
            <animate attributeName="opacity" values="0;0;0;0;0;1" dur="6s" fill="freeze"/>
            Tool Setup
          </text>
          
          <text x="400" y="5" textAnchor="middle" fill="#ffffff" fontSize="11" fontFamily="system-ui" fontWeight="500" opacity="0">
            <animate attributeName="opacity" values="0;0;0;0;0;0;1" dur="6s" fill="freeze"/>
            Assembly
          </text>
          
          <text x="505" y="5" textAnchor="middle" fill="#ffffff" fontSize="11" fontFamily="system-ui" fontWeight="500" opacity="0">
            <animate attributeName="opacity" values="0;0;0;0;0;0;0;1" dur="6s" fill="freeze"/>
            Waiting Upstream
          </text>
          
          <text x="640" y="5" textAnchor="middle" fill="#ffffff" fontSize="11" fontFamily="system-ui" fontWeight="500" opacity="0">
            <animate attributeName="opacity" values="0;0;0;0;0;0;0;0;1" dur="6s" fill="freeze"/>
            Assembly
          </text>
        </g>
        
        {/* Time categories */}
        <g transform="translate(50, 200)">
          <rect x="0" y="0" width="20" height="15" rx="3" fill="url(#productiveGrad)"/>
          <text x="30" y="12" fill="#10b981" fontSize="14" fontFamily="system-ui" fontWeight="500">
            Value Add Time (25%)
          </text>
          
          <rect x="200" y="0" width="20" height="15" rx="3" fill="url(#nonValueGrad)"/>
          <text x="230" y="12" fill="#ef4444" fontSize="14" fontFamily="system-ui" fontWeight="500">
            Non-Value Add Time (75%)
          </text>
        </g>
        
        {/* Key insight */}
        <g transform="translate(300, 260)">
          <rect x="-250" y="-25" width="500" height="50" rx="8" fill="rgba(30, 41, 59, 0.9)" stroke="rgba(71, 85, 105, 0.4)" strokeWidth="1"/>
          
          <text x="-230" y="-8" fill="#06b6d4" fontSize="18" fontFamily="system-ui" fontWeight="600">
            ⏱️ MotionLogic® identifies non-value add activities
          </text>
          <text x="-230" y="10" fill="#9ca3af" fontSize="14" fontFamily="system-ui">
            Repositioning • Tool reloading • Waiting for upstream processes
          </text>
        </g>
        
        {/* Pie chart visualization */}
        <g transform="translate(650, 230)">
          {/* Green section (25% - Task Time) */}
          <circle cx="0" cy="0" r="40" fill="none" stroke="#10b981" strokeWidth="12" 
                  strokeDasharray="63 188" strokeDashoffset="0"/>
          
          {/* Red section (75% - Non-Value Add) */}
          <circle cx="0" cy="0" r="40" fill="none" stroke="#ef4444" strokeWidth="12" 
                  strokeDasharray="188 63" strokeDashoffset="-63"/>
          
          <text x="0" y="5" textAnchor="middle" fill="#ef4444" fontSize="18" fontFamily="system-ui" fontWeight="700">
            75%
          </text>
        </g>
      </svg>
    </div>
  );
};

export default TimeMotionVisualization;